import { Box, Stack, Typography } from '@mui/material';
import { NoteStatus as Status } from '../../../../Models/ReWeightingModels/Workspace';
import { statusLabels } from '../../workspaceFormatting';

const colors: Record<Status, string> = {
  open: 'primary.main', closed: 'success.main', review: 'warning.main', expired: 'error.main',
};

export default function NoteStatus({ status }: { status: Status }) {
  return (
    <Stack component="span" direction="row" alignItems="center" spacing={0.75} sx={{ flexShrink: 0, color: colors[status] }}>
      <Box component="span" aria-hidden sx={{ width: 6, height: 6, borderRadius: '50%', bgcolor: 'currentColor' }} />
      <Typography component="span" variant="caption" fontWeight={600} sx={{ whiteSpace: 'nowrap' }}>{statusLabels[status]}</Typography>
    </Stack>
  );
}
